<button type="button" (click)="onClick()"><span><i class="pi pi-envelope"></i> Odeslat do DS</span></button>
<p-dialog header="Probíhá uložení žádosti a přesměrování do systému Datové schránky." [(visible)]="block" [modal]="true" [closable]="false"
          [style]="{'text-align': 'center'}">
  <p-progress-spinner ariaLabel="Načítání" />
</p-dialog>

